import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-68acb376"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "course-info-panel" }
const _hoisted_2 = { class: "course-info-top" }
const _hoisted_3 = { class: "button-description" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-s-medium" }, "This course expired on ", -1))
const _hoisted_5 = { class: "text-s-bold color-red" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-s-medium" }, "You will not receive credits after completion", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-l-bold" }, "Course Progress", -1))
const _hoisted_8 = { class: "button-description" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-s-medium" }, "You enrolled in this course on ", -1))
const _hoisted_10 = { class: "text-s-bold" }
const _hoisted_11 = { class: "course-info-credits" }
const _hoisted_12 = {
  key: 0,
  class: "credits-list"
}
const _hoisted_13 = { class: "text-m-bold" }
const _hoisted_14 = { class: "text-m-medium" }
const _hoisted_15 = {
  key: 1,
  class: "text-m-medium"
}
const _hoisted_16 = { class: "course-info-details" }
const _hoisted_17 = { class: "details-list" }
const _hoisted_18 = {
  key: 0,
  class: "details-item details-item-type"
}
const _hoisted_19 = { class: "text-m-bold" }
const _hoisted_20 = { class: "details-item details-item-release" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-m-medium" }, "Released on ", -1))
const _hoisted_22 = { class: "text-m-bold" }
const _hoisted_23 = {
  key: 1,
  class: "details-item details-item-expires"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-m-medium" }, "Expires on ", -1))
const _hoisted_25 = { class: "text-m-bold" }
const _hoisted_26 = {
  key: 2,
  class: "details-item details-item-estimate"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-m-medium" }, "Estimated time ", -1))
const _hoisted_28 = { class: "text-m-bold" }
const _hoisted_29 = {
  key: 3,
  class: "details-item details-item-langs"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-m-medium" }, "Available in ", -1))
const _hoisted_31 = { class: "text-m-bold" }
const _hoisted_32 = { class: "details-item details-item-price" }
const _hoisted_33 = { class: "text-m-bold" }
const _hoisted_34 = {
  key: 0,
  class: "course-info-lc"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($props.previewData.is_expired)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("button", {
              class: "button primary large w-full",
              onClick: $setup.startCourse
            }, "Start " + _toDisplayString($props.previewData.learning_center_id ? "Module" : "Course"), 1),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString($setup.formatDate($props.previewData.expired_at, "MMMM D, YYYY")), 1),
              _hoisted_6
            ])
          ], 64))
        : ($setup.courseHasNotStarted)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("button", {
                class: "button primary large w-full",
                onClick: $setup.startCourse
              }, _toDisplayString($props.previewData.status === $setup.CourseStatusEnum.inReview ? "Review" : "Start") + " " + _toDisplayString($props.previewData.learning_center_id ? "Module" : "Course"), 1),
              ($props.previewData.status === $setup.CourseStatusEnum.inReview)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "button primary large w-full mt-8",
                    onClick: $setup.startFollowUp
                  }, "Review Follow-Up"))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _hoisted_7,
              _createVNode($setup["CourseProgressBar"], {
                class: "progress-container",
                data: $props.previewData
              }, null, 8, ["data"]),
              _createElementVNode("button", {
                class: "button primary large w-full",
                onClick: $setup.startCourse
              }, _toDisplayString($setup.startCourseButton), 1),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString($setup.formatDate($props.previewData.enrolled_at, "MMMM D, YYYY")), 1)
              ])
            ], 64))
    ]),
    _createElementVNode("div", _hoisted_11, [
      ($setup.credits?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortCredits($setup.credits), (credit) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "credits-item",
                key: credit.id
              }, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(credit.name), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(credit.value), 1)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, "No credits offered"))
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        ($props.previewData.format)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString($props.previewData.format), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("span", _hoisted_22, _toDisplayString($setup.formatDate($props.previewData.released_at, "MMMM D, YYYY")), 1)
        ]),
        ($props.previewData.expired_at)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("span", _hoisted_25, _toDisplayString($setup.formatDate($props.previewData.expired_at, "MMMM D, YYYY")), 1)
            ]))
          : _createCommentVNode("", true),
        ($props.previewData.estimated_time)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("span", _hoisted_28, _toDisplayString($setup.getEstimatedTime($props.previewData.estimated_time)), 1)
            ]))
          : _createCommentVNode("", true),
        ($props.previewData.languages?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("span", _hoisted_31, _toDisplayString($setup.getLanguages()), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, _toDisplayString($setup.getPrice($props.previewData.price)), 1)
        ])
      ])
    ]),
    ($props.previewData.learning_center_id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createVNode(_component_router_link, {
            class: "text-link",
            to: { name: $setup.routesName.center, params: { id: $props.previewData.learning_center_id }, query: { inReview: $props.previewData.status === $setup.CourseStatusEnum.inReview ? 'true' : undefined } }
          }, {
            default: _withCtx(() => [
              _createTextVNode("View all modules from the Learning Center")
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true)
  ]))
}